import { detectPlatformName } from "./detect";
import { createTelegramPlatform } from "./telegram";
import { createIosPlatform } from "./ios";
import { createWebPlatform } from "./web";
import type { Platform } from "./types";

let platformInstance: Platform | null = null;

export function getPlatform(): Platform {
  if (platformInstance !== null) {
    return platformInstance;
  }

  const platformName = detectPlatformName();

  if (platformName === "ios") {
    platformInstance = createIosPlatform();
  } else if (platformName === "web") {
    platformInstance = createWebPlatform();
  } else {
    platformInstance = createTelegramPlatform();
  }

  return platformInstance;
}

export function __setPlatformForTests(p: Platform | null): void {
  platformInstance = p;
}

/** DUE-255: the same injection point under a name that isn't a lie — the
 * mock-API dev mode installs a browser platform through it too, and calling
 * that "for tests" at the one call site outside tests reads as a mistake. */
export const __setPlatform = __setPlatformForTests;
